/*
 * ConflictDialog Messages
 *
 * This contains all the text for the ConflictDialog component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  affectChoices: {
    id: 'cwt.translations.ConflictDialog.AffectChoices',
    defaultMessage: 'This new selection doesn’t work with some of your previous items.',
  },
  conflictTitle: {
    id: 'cwt.translations.ConflictDialog.Title',
    defaultMessage: 'Great choice!',
  },
  conflictSubtitle: {
    id: 'cwt.translations.ConflictDialog.Subtitle',
    defaultMessage: 'But...',
  },
  stop: {
    id: 'cwt.translations.ConflictDialog.Stop',
    defaultMessage: 'Stop!',
  },
  continue: {
    id: 'cwt.translations.ConflictDialog.Continue',
    defaultMessage: 'Continue with selection',
  },
  continueSubtitle: {
    id: 'cwt.translations.ConflictDialog.ContinueSubtitle',
    defaultMessage: 'and make changes if necessary',
  },
  usePrevious: {
    id: 'cwt.translations.ConflictDialog.usePrevious',
    defaultMessage: 'Use previous selection',
  },
  conflictDescription: {
    id: 'cwt.translations.ConflictDialog.conflictDescription',
    defaultMessage: 'This new selection doesnt work with some of your previous items.',
  },
  conflictChoice: {
    id: 'cwt.translations.ConflictDialog.conflictChoice',
    defaultMessage: 'To purchase your worktop, choose a different option for the following:',
  },
  priceErrorTitle: {
    id: 'cwt.translations.PriceErrorDialog.Title',
    defaultMessage: "The worktop price can't be calculated",
  },
  priceErrorSubtitle: {
    id: 'cwt.translations.PriceErrorDialog.Subtitle',
    defaultMessage: 'Seems like we are missing some input. To give you a good price estimation, we need you to give us some more information',
  },
  priceErrorDescription: {
    id: 'cwt.translations.PriceErrorDialog.Description',
    defaultMessage: 'To give you a good price estimation, we need you to give us some more information.',
  },
  priceErrorOkButton: {
    id: 'cwt.translations.PriceErrorDialog.OkButton',
    defaultMessage: 'Ok',
  },
  selectionErrorTitle: {
    id: 'cwt.translations.SelectionError.Title',
    defaultMessage: 'Worktop selection',
  },
  selectionErrorSubtitle: {
    id: 'cwt.translations.SelectionError.Subtitle',
    defaultMessage: "We can't produce a worktop with the current combination of choices, so we can't calculate a price",
  },
  selectionErrorDescription: {
    id: 'cwt.translations.SelectionError.Description',
    defaultMessage: 'You need to first select a material and an expression to continue',
  },
  manualConflictDescription: {
    id: 'cwt.translations.Dialog.ManualConflictDescription',
    defaultMessage: 'Change the following items to see the worktop price:',
  },
  automaticConflictDescription: {
    id: 'cwt.translations.Dialog.AutomaticConflictDescription',
    defaultMessage: 'We changed this for you. Check it out.',
  },
  basicFeatures: {
    id: 'cwt.translations.OptionInfoDialog.BasicFeatures',
    defaultMessage: 'Basic features',
  },
  goodToKnow: {
    id: 'cwt.translations.OptionInfoDialog.GoodToKnow',
    defaultMessage: 'Good to know',
  },
  goodToKnowOKButton: {
    id: 'cwt.translations.OptionInfoDialog.goodToKnowOKButton',
    defaultMessage: 'Ok',
  },
  productDescription: {
    id: 'cwt.translations.OptionInfoDialog.ProductDescription',
    defaultMessage: 'Product description',
  },
  dismiss: {
    id: 'cwt.translations.Dialog.Dismiss',
    defaultMessage: 'Dismiss',
  },
  codeNotFound: {
    id: 'cwt.translations.LoadPlanErrorDialog.CodeNotFound',
    defaultMessage: 'Code not found',
  },
  planNotFound: {
    id: 'cwt.translations.LoadPlanErrorDialog.planNotFound',
    defaultMessage: "We couldn't load the worktop plan. Try again, and see if the problem persists",
  },
  vpcErrorTitle: {
    id: 'cwt.translations.VPCErrorDialog.Header',
    defaultMessage: 'Uh-oh!',
  },
  vpcErrorSubtitle: {
    id: 'cwt.translations.VPCErrorDialog.Subtitle',
    defaultMessage: 'Something went wrong...',
  },
  vpcErrorDescription: {
    id: 'cwt.translations.VPCErrorDialog.Description',
    defaultMessage: "We couldn't load the worktop plan. Please check your internet connection and try again.",
  },
  retrySave: {
    id: 'cwt.translations.SavePlanErrorDialog.RetrySave',
    defaultMessage: 'Retry saving',
  },
  vpcSaveErrorTitle: {
    id: 'cwt.translations.VPCSaveErrorDialog.Header',
    defaultMessage: "Uh-oh - your plan wasn't saved!",
  },
  vpcSaveErrorSubtitle: {
    id: 'cwt.translations.VPCSaveErrorDialog.Subtitle',
    defaultMessage: "Something went wrong and we couldn't save your plan. Please check your internet connection and try again.",
  },
  vpcSaveRetrySave: {
    id: 'cwt.translations.VPCSaveErrorDialog.RetrySave',
    defaultMessage: 'Retry',
  },
  oldPrice: {
    id: 'cwt.translations.PriceDifferenceDialog.OldPrice',
    defaultMessage: 'Old price',
  },
  newPrice: {
    id: 'cwt.translations.PriceDifferenceDialog.NewPrice',
    defaultMessage: 'New price',
  },
  priceDifferenceMessage: {
    id: 'cwt.translations.PriceDifferenceDialog.Message',
    defaultMessage: 'One or more items have new prices since you last saved this worktop.',
  },
  headsUp: {
    id: 'cwt.translations.Dialog.HeadsUp',
    defaultMessage: 'Heads up!',
  },
  priceDifferenceOkButton: {
    id: 'cwt.translations.PriceDifferenceDialog.OkButton',
    defaultMessage: 'Ok, got it!',
  },
  newPriceTitle: {
    id: 'cwt.translations.Dialog.NewCountryDialog.Title',
    defaultMessage: 'New price',
  },
  newCountrySubtitle: {
    id: 'cwt.translations.Dialog.NewCountryDialog.SubTitle',
    defaultMessage: 'This plan was created in a different country than the current one',
  },
  newCountryMessage: {
    id: 'cwt.translations.Dialog.NewCountryDialog.Message',
    defaultMessage: 'The price of your worktop has been adjusted to local prices and currency. You can change back at any time.',
  },
  unavailableOptionTitle: {
    id: 'cwt.translations.UnavailableOptionDialog.Title',
    defaultMessage: 'When one door closes, another one opens..',
  },
  unavailableOptionSubtitle: {
    id: 'cwt.translations.UnavailableOptionDialog.Subtitle',
    defaultMessage: 'Some of your choices are no longer available',
  },
  unavailableOptionDescription: {
    id: 'cwt.translations.UnavailableOptionDialog.Description',
    defaultMessage: 'No need to worry, we have marked the sections where you need to make a new choice.',
  },
  newFeaturesTitle: {
    id: 'cwt.translations.NewFeaturesDialog.Title',
    defaultMessage: 'What´s new?',
  },
  newFeaturesSubtitle: {
    id: 'cwt.translations.NewFeaturesDialog.Subtitle',
    defaultMessage: 'Here´s what´s changed since your last visit:',
  },
  comparePlans: {
    id: 'cwt.translations.NewFeaturesDialog.ComparePlans',
    defaultMessage: 'Compare plans',
  },
  cutOuts: {
    id: 'cwt.translations.NewFeaturesDialog.CutOuts',
    defaultMessage: 'cut-outs',
  },
  includedInPrice: {
    id: 'cwt.translations.PriceIsIncludedDialog.Included',
    defaultMessage: 'Included in the price',
  },
  includedBodyTextEnabled: {
    id: 'cwt.translations.IncludedBodyTextEnabled',
    defaultValue: false,
  },
  notIncludedBodyTextEnabled: {
    id: 'cwt.translations.NotIncludedBodyTextEnabled',
    defaultValue: false,
  },
  notIncludedInPrice: {
    id: 'cwt.translations.PriceIsIncludedDialog.NotIncluded',
    defaultMessage: 'Not included in the price',
  },
  includedBody: {
    id: 'cwt.translations.PriceIsIncludedDialog.IncludedBody',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Write information for what IS included in the price',
    },
  },
  notIncludedBody: {
    id: 'cwt.translations.PriceIsIncludedDialog.NotIncludedBody',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Write information here for what is NOT included in the price',
    },
  },
});
